import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface TemplateExcludeState {
	excludedPlatforms: string[];
	loading: boolean;
}

const initialState: TemplateExcludeState = {
	excludedPlatforms: [],
	loading: false,
};

export const templateExcludeSlice = createSlice({
	name: "templateExclude",
	initialState,
	reducers: {
		setExcludedPlatforms: (state, action: PayloadAction<string[]>) => {
			state.excludedPlatforms = action.payload;
		},
		setLoading: (state, action: PayloadAction<boolean>) => {
			state.loading = action.payload;
		},
	},
});

export const { setExcludedPlatforms, setLoading } =
	templateExcludeSlice.actions;

export default templateExcludeSlice.reducer;
